import { Certificado } from "@/../common/types/certificado/Certificado"


export function obterCorDoStatusDoCertificado(certificado: Certificado) {
    switch (certificado.status) {
        case 'solicitado': return 'warning'
        case 'aprovado': return 'success'
        case 'rejeitado': return 'error'
    }
}
